var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { __decorate, __metadata } from "tslib";
import infraService from "@/core/services/infraService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Usuario_Unidade_RoleActions } from "@/store/enums/InfraEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Usuario_Unidade_RoleModule = class Usuario_Unidade_RoleModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Usuario_Unidade_RoleActions.POST_USUARIO_UNIDADE_ROLE](data) {
        return new Promise(resolve => {
            infraService.post("Usuario_Unidade_Role/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Usuario_Unidade_RoleActions.POSTRANGE_USUARIO_UNIDADE_ROLE](data) {
        return new Promise(resolve => {
            infraService.post("Usuario_Unidade_Role/PostRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Usuario_Unidade_RoleActions.PUT_USUARIO_UNIDADE_ROLE](data) {
        return new Promise(resolve => {
            infraService.put("Usuario_Unidade_Role/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Usuario_Unidade_RoleActions.DELETE_USUARIO_UNIDADE_ROLE](data) {
        return new Promise(resolve => {
            infraService.delete("Usuario_Unidade_Role/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Usuario_Unidade_RoleActions.DELETE_RANGE_USUARIO_UNIDADE_ROLE](data) {
        return new Promise(resolve => {
            infraService.delete("Usuario_Unidade_Role/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Usuario_Unidade_RoleActions.FILTER_USUARIO_UNIDADE_ROLE](data) {
        return new Promise(resolve => {
            infraService.post("Usuario_Unidade_Role/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Usuario_Unidade_RoleActions.GET_USUARIO_UNIDADE_ROLE]() {
        return new Promise(resolve => {
            infraService.get("Usuario_Unidade_Role/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Usuario_Unidade_RoleActions.GETWITHDISABLED_USUARIO_UNIDADE_ROLE]() {
        return new Promise(resolve => {
            infraService.get("Usuario_Unidade_Role/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Usuario_Unidade_RoleActions.GET_BY_ID_USUARIO_UNIDADE_ROLE](data) {
        return new Promise(resolve => {
            infraService.get("Usuario_Unidade_Role/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_Unidade_RoleModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_Unidade_RoleModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_Unidade_RoleModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_Unidade_RoleModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_Unidade_RoleModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_Unidade_RoleModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Usuario_Unidade_RoleModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Usuario_Unidade_RoleModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Usuario_Unidade_RoleModule.prototype, _j, null);
Usuario_Unidade_RoleModule = __decorate([
    Module
], Usuario_Unidade_RoleModule);
export default Usuario_Unidade_RoleModule;
//# sourceMappingURL=Usuario_Unidade_RoleModule.js.map